import { useEffect } from 'react';
import { liveConnection } from './liveConnection';

export function SocketConnection({ children }) {
  useEffect(() => {
    liveConnection.handleSocketInit();
  }, []);

  return children;
}
